export const studyDataActionNames = {
  SET_STUDY_TIME: "SET_STUDY_TIME",
};

export const setStudyTime = (payload) => {
  return {
    type: studyDataActionNames.SET_STUDY_TIME,
    payload: payload,
  };
};
